<script setup lang="ts">

</script>

<template>
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8 1H17.2C18.19 1 19 1.81 19 2.8V13.6C19 14.59 18.19 15.4 17.2 15.4H2.8C1.81
      15.4 1 14.59 1 13.6V2.8C1 1.81 1.81 1 2.8 1Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 2.80078L10 9.10078L1 2.80078"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>

</style>
